// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__vjP1b","content":"LoadingAlert_content__16__z"};